import { noop } from 'lodash';
import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import { IconArrow, SettingsItem, SettingsItemRightContent, SettingsItemTitle, } from 'design-system';
import Text from 'design-system/Text';
import { useAppSelector } from 'store/hooks';
import { selectShouldShowAutosave } from 'features/pots/reducers/selectors';
const TierBenefit = ({ item, active, onPressBenefit, customName, customDescription, customIcon, disabled, withArrow, }) => {
    const shouldShowAutosave = useAppSelector(selectShouldShowAutosave);
    const onBenefitPressed = useCallback(() => {
        onPressBenefit?.(item);
    }, [item, onPressBenefit]);
    return (<SettingsItem onPress={!active || disabled ? noop : onBenefitPressed} disabled={disabled} title={<View>
          {item.isComingSoon && !shouldShowAutosave ? (<Text Text-14 Primary>
              COMING SOON
            </Text>) : null}
          <SettingsItemTitle>{customName || item?.name}</SettingsItemTitle>
        </View>} description={customDescription || item?.text} icon={customIcon || item?.icon}>
      <SettingsItemRightContent>
        {active && withArrow ? <IconArrow /> : null}
      </SettingsItemRightContent>
    </SettingsItem>);
};
export default memo(TierBenefit);
